import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@one-dash/aside-menu");
